// API_BASE_URL is the base URL for the API
export const API_BASE_URL = 'https://service.newjerseypla.org/api'; 
